module.exports = __webpack_public_path__ + "img/logo_stadtol_black_white.28b15d4d.png";